module.exports = __webpack_public_path__ + "img/sld_inverter_green_b1_green.fcb89580.svg";